import styled, { css } from 'styled-components'
import { maxWidth, noTouch } from '@/assets/styles/mixins.css.js'
import vars from '@/assets/styles/vars'

const Error = styled.div`
  ${props =>
    props.view !== 404 &&
    css`
      display: flex;
      flex-direction: column;
      height: 100vh;
      min-height: 400px;
      min-width: 320px;
    `}
`

Error.Text = styled.div`
  font-size: 20px;
  line-height: 1.6;
  white-space: pre-line;

  &:not(:last-child) {
    margin-bottom: 32px;
  }

  a {
    color: var(--color-decor);
    text-decoration: underline;
    transition: border-color 0.3s ease;

    ${noTouch()`
      &:hover {
        color: var(--color-decor-dark);
      }

      &:focus:not(:hover) {
        outline: 1px solid var(--color-decor-dark);;
      }
    `}
  }
`

Error.Btn = styled.div`
  --button-width: 270px;

  ${maxWidth(vars.breakpoints.lMobile)`
    --button-width: 100%;
  `}
`

export default Error
